import type { MeetingSampleSizeMapping } from '../../gql';

import { randNumber } from '@ngneat/falso';

/**
 * Returns a mocked meeting-sample size mapping (one row of a `StyleMeetingSampleTemplate`).
 * Size/length numbers are strings here (they map to the Long size/length numbers on style EANs).
 * Defaults to a size-only row; pass `length` to build a size x length row.
 */
const mockMeetingSampleSizeMapping = (
    overwrite?: Partial<MeetingSampleSizeMapping>
): MeetingSampleSizeMapping => {
    const sizeNumber = String(randNumber({ min: 30, max: 44 }));

    return {
        quantity: randNumber({ min: 1, max: 12 }),
        size: {
            sizeNumber,
            sizeName: sizeNumber,
            ['__typename']: 'Size',
        },
        length: null,
        ...overwrite,
        ['__typename']: 'SizeMapping',
    };
};

export { mockMeetingSampleSizeMapping };
